export function validateFileSize(file: File, maxMB: number): string | null {
  if (file.size > maxMB * 1024 * 1024) {
    return `El archivo supera el tamaño máximo permitido (${maxMB} MB).`;
  }
  return null;
}
